/// <reference path="../../../typings/browser.d.ts" />
/// <reference path="../../../customtypings/selectize/selectize.d.ts" />
/// <reference path="../../../customtypings/angular-google-maps/angular-google-maps.d.ts" />

namespace Application.Controllers {
    'use strict';

    import INodeLocation = Models.INodeLocation;

    export interface IHotspotModalScope extends ng.IScope {
        hotspot: Models.IHotspot;
        locationEditable: boolean;
        isNewHotspot: boolean;
        modalClose: () => void;
        modalSave: () => void;
        geocodingResolve: (address: string) => void;
        geolocationAddress: string;
        geolocationResponses: google.maps.custom.IAddress[];
        selectedLocation: string;
        openMap: () => void;
    }


    /**
     * HotspotModalController class
     */
    export class HotspotModalController {
        public static templateURL: string = "decorators/modals/hotspot-modal.html";
        public static ID: string = "#id-hotspot-modal";
        public static $name: string = "hotspotModalController";
        public static $inject: string[] = ['$scope',
                                           'close',
                                           'hotspot',
                                           'locationEditable',
                                           '$timeout',
                                           'geocodeService',
                                           'ModalService',
                                           ];

        private scope: IHotspotModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;
        private $timeout: ng.ITimeoutService;
        private geocodeService: Services.GeocodeService;
        private modalService: ngModal.IModalService;
        private locationSelectize: Selectize.IApi<string, google.maps.custom.IAddress>;

        /**
         * Constructor
         */
        constructor($scope: IHotspotModalScope,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    hotspot: Models.IHotspot,
                    locationEditable: boolean,
                    $timeout: ng.ITimeoutService,
                    geocodeService: Services.GeocodeService,
                    modalService: ngModal.IModalService) {
            $timeout(() => {
                window.altair_admin_common_init();
                window.altair_forms_validation();
            }, 500);
            this.scope = $scope;
            this.scope.isNewHotspot = hotspot === undefined;

            if (hotspot === undefined)
                this.scope.hotspot = Models.Hotspot.Empty();
            else
                this.scope.hotspot = hotspot;

            this.scope.locationEditable = locationEditable;
            this.close = close;
            this.$timeout = $timeout;
            this.geocodeService = geocodeService;
            this.modalService = modalService;
            this.locationSelectize = undefined;

            this.scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.scope.modalSave = (): void => {
                if (this.scope.hotspot.name !== undefined && this.scope.hotspot.name !== "") {
                    this.close(this.scope.hotspot);
                }
            };

            this.scope.openMap = (): void => {
                let self: HotspotModalController = this;
                this.modalService.showModal({
                    templateUrl: Application.Controllers.SetLocationModalController.templateURL,
                    controller: Application.Controllers.SetLocationModalController.$name,
                    inputs: {
                        initLat: 40.4902688,
                        initLong: -3.6932825,
                    },
                }).then((modal: ngModal.IModalObject) => {
                    let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.SetLocationModalController.ID,
                                                        {bgclose: false, modal: false, keyboard: false});
                    modalElem.show();
                    modal.scope.initMap();
                    modal.close.then((result: INodeLocation) => {
                        modalElem.hide();
                        if (result) {
                            if (self.scope.hotspot.geoElement === undefined)
                                self.scope.hotspot.geoElement = new Models.GeoElement();
                            self.scope.hotspot.geoElement.auto = false;
                            self.scope.hotspot.geoElement.manualLat = result.lat;
                            self.scope.hotspot.geoElement.manualLong = result.lng;
                            self.scope.hotspot.physicalLocation = result.address;
                        }
                    });

                });
            };

            this.scope.geocodingResolve = (address: string): void => {
                this.geocodeService.geocode(address)
                    .then((res: google.maps.custom.IGeocodingResponse) => {
                        this.scope.geolocationResponses = res.results;
                        this.locationSelectize.clearOptions();
                        this.locationSelectize.clearCache();
                        if (this.scope.geolocationResponses !== undefined && this.scope.geolocationResponses.length > 0) {
                            this.locationSelectize.addOption(this.scope.geolocationResponses);
                            this.locationSelectize.refreshItems();
                            this.locationSelectize.refreshOptions(true);
                            // let dropdown: JQuery = $($('#select_location').next().children()[1]);
                            // if (dropdown.hasClass('selectize-dropdown'))
                            //     dropdown.show();
                        }
                    });
            };

            this.scope.$on('$destroy', () => {
                if (this.locationSelectize)
                    this.locationSelectize.destroy();
            });
        }
    }
}
